import { initializeApp, getApps } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';

// Firebase configuration
// We'll use the same API key from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // Add other config as needed, but apiKey is the minimum required for phone auth
};

// Initialize Firebase only if API key is available
let app = null;
let auth = null;
let recaptchaVerifier = null;

if (firebaseConfig.apiKey) {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApps()[0];
  }

  // Initialize Auth
  auth = getAuth(app);
} else {
  console.warn('REACT_APP_FIREBASE_API_KEY not found. reCAPTCHA verification will not work.');
}

// Get or create reCAPTCHA verifier
export const getRecaptchaVerifier = () => {
  if (!auth) {
    throw new Error('Firebase Auth not initialized. Please set REACT_APP_FIREBASE_API_KEY');
  }

  // Ensure container exists
  let container = document.getElementById('recaptcha-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'recaptcha-container';
    container.style.display = 'none';
    document.body.appendChild(container);
  }

  // Clear existing verifier if any
  if (recaptchaVerifier) {
    try {
      recaptchaVerifier.clear();
    } catch (e) {
      // Ignore errors if already cleared
    }
    recaptchaVerifier = null;
  }

  // Create invisible reCAPTCHA verifier
  recaptchaVerifier = new RecaptchaVerifier(auth, container, {
    size: 'invisible',
    callback: () => {
      // reCAPTCHA solved automatically
      console.log('reCAPTCHA verified');
    },
    'expired-callback': () => {
      // Response expired
      console.log('reCAPTCHA expired');
      recaptchaVerifier = null; // Reset to get a new one
    }
  });
  
  return recaptchaVerifier;
};

// Send verification code using Firebase SDK (client-side)
// This is more reliable than using REST API with reCAPTCHA token
export const sendPhoneVerificationCode = async (phoneNumber) => {
  if (!auth) {
    throw new Error('Firebase Auth not initialized. Please set REACT_APP_FIREBASE_API_KEY');
  }

  try {
    // Get or create reCAPTCHA verifier
    const verifier = getRecaptchaVerifier();
    
    // Use Firebase SDK's signInWithPhoneNumber which handles reCAPTCHA internally
    // This returns a ConfirmationResult with verificationId that we can use on the server
    const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, verifier);
    
    // Return the verification ID (sessionInfo equivalent) that the server can use
    return {
      sessionInfo: confirmationResult.verificationId
    };
  } catch (error) {
    console.error('Error sending verification code:', error);
    // Reset verifier on error so we can try again
    if (recaptchaVerifier) {
      try {
        recaptchaVerifier.clear();
      } catch (e) {
        // Ignore clear errors
      }
      recaptchaVerifier = null;
    }
    throw error;
  }
};

export { auth };
export default app;

